<div class="notifications-container">
    <div class="notifications-header">
      <h2 class="text-white">Notificaciones Recientes</h2>
      <p>{{ notifications.length }} notificaciones</p>
      <button class="mark-all" (click)="markAllAsRead()">Marcar todas como leídas</button>
    </div>

    <div class="notifications-list">
      <div
        *ngFor="let notification of notifications"
        class="notification-item"
        [class.unread]="!notification.read"
        (click)="markAsRead(notification)"
      >
        <div class="notification-icon" [ngClass]="notification.type">
          <span class="material-icons">{{ notification.icon }}</span>
        </div>
        <div class="notification-content">
          <h3>{{ notification.title }}</h3>
          <p>{{ notification.message }}</p>
          <div class="notification-footer">
            <span class="material-icons time-icon">schedule</span>
            <span>{{ notification.date }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
